import React, { ReactNode, createContext, useCallback, useContext, useMemo } from 'react';
import { buildCoachColorMap, CoachColor, getCoachColor } from './utils';

const CoachColorContext = createContext<ReadonlyMap<string, CoachColor> | null>(null);

type CoachColorProviderProps = {
    coachIds: string[];
    children: ReactNode;
};

export const CoachColorProvider = ({ coachIds, children }: CoachColorProviderProps) => {
    const coachIdSignature = useMemo(
        () => Array.from(new Set(coachIds.filter(Boolean))).sort().join('\u0001'),
        [coachIds]
    );
    const colors = useMemo(
        () => buildCoachColorMap(coachIdSignature ? coachIdSignature.split('\u0001') : []),
        [coachIdSignature]
    );

    return <CoachColorContext.Provider value={colors}>{children}</CoachColorContext.Provider>;
};

export const useCoachColor = (coachId?: string) => {
    const rosterColors = useContext(CoachColorContext);
    return (coachId ? rosterColors?.get(coachId) : undefined) || getCoachColor(coachId);
};

export const useCoachColorResolver = () => {
    const rosterColors = useContext(CoachColorContext);
    return useCallback(
        (coachId?: string) => (coachId ? rosterColors?.get(coachId) : undefined) || getCoachColor(coachId),
        [rosterColors]
    );
};
